export default "__VITE_ASSET__xBIP9aO8__"